import { Image, CTA } from '../..';
import './FeaturedAncillaryCard.scss';

export default function FeaturedAncillaryCard({ title, image, description, cta }) {
	return (
		<div className="featured-ancillary-card">
			<Image className="featured-ancillary-card__img" src={image.src} alt={image.alt} />

			<div className="featured-ancillary-card__text">
				<h3 className="ty-c1 featured-ancillary-card__text__title">{title}</h3>

				<div className="ty-b2 featured-ancillary-card__text__description">{description}</div>
			</div>

			<CTA type="primary" link={cta.href}>
				{cta.label}
			</CTA>
		</div>
	);
}
